exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".address-info{width:270px;font-size:16px;font-style:normal}.address-info .contact_item_loc{margin:35px 0 25px}.address-info .contact_item_loc:before{content:url(" + require("./icon-location.png") + ");width:21px;height:32px;float:left;margin-right:10px}.address-info .contact_item_tel:before{content:url(" + require("./icon-telephone.png") + ");width:15px;height:15px;float:left;margin-right:10px}.address-info .contact_item_tel>a{text-decoration:none;color:inherit}.address-info .contact_item_mail:before{content:url(" + require("./icon-mail.png") + ");width:18px;height:15px;float:left;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21ecc651","scoped":false,"hasInlineConfig":true}!./src/components/address-info/address-info.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-21ecc651","scoped":false,"hasInlineConfig":true}!./src/components/address-info/address-info.css
// module chunks = index